// noinspection JSUnusedGlobalSymbols

type EverySecond = ((second: number) => any) | null | undefined;
type OnFinish = () => any;

export interface CountDown {
  start: (limit: number, everySecond: EverySecond, onFinish: OnFinish) => void;
  stop: () => void;
}

export const useCountDown = (): CountDown => {
  let active: boolean = false;
  let currentTimeout: NodeJS.Timeout | null = null;

  const start = (
    limit: number,
    everySecond: EverySecond,
    onFinish: OnFinish
  ) => {
    active = true;
    if (everySecond) everySecond(limit);
    setCurrentTimeout(makeStep(limit - 1, everySecond, onFinish));
  };

  const stop = () => {
    active = false;
    if (currentTimeout) clearTimeout(currentTimeout);
    currentTimeout = null;
  };

  const setCurrentTimeout = (timeout: NodeJS.Timeout) => {
    currentTimeout = timeout;
  };

  const makeStep = (
    currentSecond: number,
    callback: EverySecond,
    onFinish: OnFinish
  ): NodeJS.Timeout => {
    return setTimeout(() => {
      if (active) {
        if (callback) callback(currentSecond);
        if (currentSecond > 0) {
          setCurrentTimeout(makeStep(currentSecond - 1, callback, onFinish));
        } else {
          onFinish();
        }
      }
    }, 1000);
  };

  return { start, stop };
};
